exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.news-body a {\n\ttext-decoration: underline;\n}\n", ""]);

// exports
